import SingleProductDisplayComponent from '@components/ProductDisplayComponent/SingleProductDisplayComponent';
import {ProductPrices} from '@contexts/actions';
import {ProductDisplayContextProvider} from '@contexts/providers';
import {LocaleEnum} from '@enums/locale';
import {APIRequestConfig} from '@enums/request-config';
import {ProductInterface} from '@interfaces/product';
import {ProductGroupDisplayResponseData} from '@interfaces/product-group-display';
import {
  getRequireRegistrationUIDS,
  isValidURL,
  setRequireRegistrationUIDS,
} from '@lib/utils';
import {AxiosResponse} from 'axios';
import {GetServerSidePropsContext} from 'next';
import {getServerSession} from 'next-auth/next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import axios from '../../../../lib/axios';
import {authOptions} from '../../../api/auth/[...nextauth]';

export default function ProductFamilyDisplay({
  data,
}: {
  data: ProductGroupDisplayResponseData & {
    product: ProductInterface & ProductPrices;
  };
}) {
  return (
    <>
      <Head>
        <title>Liune Products Family Display Page</title>
        <meta name="description" content="Liune" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ProductDisplayContextProvider>
        <SingleProductDisplayComponent data={data} />
      </ProductDisplayContextProvider>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const {params, locale, query, ...rest} = ctx;
  const {uuid} = query;
  const session = await getServerSession(ctx.req, ctx.res, authOptions);
  if (uuid) {
    setRequireRegistrationUIDS(uuid as string, rest);
  }
  const {id} = params || {};
  try {
    const response: AxiosResponse<{
      data: ProductGroupDisplayResponseData & {
        product: ProductInterface & ProductPrices;
      };
    }> = await axios.get<any>(`store/product/${id}`, {
      headers: {
        [APIRequestConfig.X_LOCALE]: locale!,
        [APIRequestConfig.X_Requires_Registration_UUIDs]:
          getRequireRegistrationUIDS(rest) as string,
      },
    });

    const data = response.data.data;
    const redirectUrl =
      data[`product_group_redirect_url_${locale as LocaleEnum}`];
    if (redirectUrl && isValidURL(redirectUrl)) {
      return {
        redirect: {
          destination: redirectUrl,
          permanent: false,
        },
      };
    }
    return {
      props: {
        ...(await serverSideTranslations(locale!, [
          'common',
          'product-display',
        ])),
        data: response.data.data,
        session,
      },
    };
  } catch (e: any) {
    if (e.response.status < 500) {
      return {notFound: true};
    }
    throw e;
  }
}
